<template>
  <div class="column">
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <form @submit.prevent="salvarCotaDeSubsidio" class="cadastro-de-empreendimento formulario">
        <h2 class="titulo titulo_grande">Preencha todos os campos obrigatórios abaixo para editar a cota de subsídio
        </h2>
        <h3 class="subtitle is-5">
          <i class="fal fa-chart-network"></i> Dados do município
        </h3>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Projeto</label>
            <select v-model="cotaDeSubsidio.ProjetoId" required @change="informarSobreProjetoQueNaoPodeTerCotas">
              <option v-for="projeto in projetos" :value="projeto.Id"
                :selected="projeto.Id === cotaDeSubsidio.ProjetoId ? 'selected' : ''">
                {{ projeto.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_2">
            <label class="label" for="totalDeCotas">Cotas disponíveis</label>
            <input name="totalDeCotas" type="number" id="totalDeCotas" class="input uppercase"
              placeholder="Ex: 100" v-model="cotaDeSubsidio.QuantidadeDisponivel" required />
          </div>
        </div>
        <div class="grade__linha">
           <div class="grade__coluna grade__coluna_2">
            <p class="texto-informativo">Total de cotas disponibilizadas: <strong>{{cotaDeSubsidio.Quantidade}}</strong></p>
          </div>
          <div class="grade__coluna grade__coluna_2">
            <p class="texto-informativo">Cotas utilizadas: <strong>{{cotaDeSubsidio.QuantidadeUsada}}</strong></p>
          </div>
        </div>
        <hr>
        <div v-if="deveExibirBotoes" class="grade__linha">
          <router-link :to="{ name: 'ListaDeCotas' }"
            class="botao botao_cinza botao_medio u-margem-direita-pequena"
            :class="{ 'is-disabled': loading.visivel }">Cancelar</router-link>
          <button type="submit" class="botao botao_cor-terciaria botao_medio"
            :class="{ 'is-loading': loading.visivel }">Salvar cota</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Loading from '../shared/Loading';
import Alerta from '../shared/Alerta';

export default {
  name: 'cadastrar-cota',
  components: { Loading, Alerta },
  data() {
    return {
      cotaDeSubsidio: {
        CidadeId: null,
        ProjetoId: null,
        Quantidade: null,
        QuantidadeDisponivel: null
      },
      cidades: this.cidades || [],
      projetos: this.projetos || [],
      deveExibirBotoes: true,
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      mensagemParaProjetoSemCotas: "Não é possível cadastrar cotas para o projeto selecionado",
      tipoDeAlerta: null,
    };
  },
  created() {
    const idDaCota = this.$route.query.idDaCota;
    this.exibirCarregamento();
    this.$api.get(`/Cotas/${idDaCota}`).then((response) => {
        this.esconderCarregamento();
        this.cotaDeSubsidio = response.data;
        this.cotaDeSubsidio.QuantidadeDisponivel = response.data.Quantidade - response.data.QuantidadeUsada;
        return response;
      })
      .catch((error) => {
        this.tratarErro(error);
      });

    this.$api.get('/Cidade').then((response) => {
      this.cidades = [{ Id: null, Nome: 'Selecione uma cidade' }];
      this.cidades = this.cidades.concat(response.data);
      return response;
    }).catch((error) => {
      this.tratarErro(error);
    });

    this.$api.get('/Projeto/ObterVigentes').then((response) => {
        this.projetos = [{ Id: null, Nome: 'Selecione um projeto' }];
        this.projetos = this.projetos.concat(response.data);
        return response;
    }).catch((error) => {
      this.tratarErro(error);
    });
  },
  methods: {
    projetoPodeCadastrarCota(){
      if(this.cotaDeSubsidio.ProjetoId) {
        const projeto = this.projetos.filter(p=> p.Id == this.cotaDeSubsidio.ProjetoId)[0]
        return projeto.EhBonusMoradia
      }
    },
    salvarCotaDeSubsidio() {
      this.exibirCarregamento('Só um momento, estamos cadastrando uma nova cota de subsídio...');
      this.cotaDeSubsidio.Quantidade = +this.cotaDeSubsidio.QuantidadeDisponivel + +this.cotaDeSubsidio.QuantidadeUsada;
      this.$api.put('/Cotas', this.cotaDeSubsidio).then(() => {
        this.$router.push({ name: 'ListaDeCotas' });
      }).catch((error) => {
        this.tratarErro(error);
      });
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    informarSobreProjetoQueNaoPodeTerCotas(){
      this.tipoDeAlerta = 'atencao';

      if(!this.projetoPodeCadastrarCota()){
        this.mensagemDeAlerta = "Não é possível cadastrar cotas para o projeto selecionado";
        this.deveExibirBotoes = false;
      }
      else{
        this.mensagemDeAlerta = null;
        this.deveExibirBotoes = true;
      }
    },
    tratarErro(error) {
      this.esconderCarregamento();
      this.tipoDeAlerta = 'erro';
      const mensagensDeErro = error.response.data.Message;
      this.mensagemDeAlerta = mensagensDeErro || 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';
    }
  },
};
</script>



// WEBPACK FOOTER //
// EditarCota.vue?3d270e2c